

















































import { Component, Vue } from "vue-property-decorator";

import NoteBox from "@/basics/boxes/NoteBox.vue";
import CSelect, { SelectOption } from "@/basics/selects/CSelect.vue";
import CButton from "@/basics/buttons/CButton.vue";
import { GroupAllData, GROUP_ALL } from "@/graphql/query/group/all";
import SimpleTable from "@/basics/table/SimpleTable.vue";
import EditIcon from "@/basics/icon/EditIcon.vue";
import EditModal from "@/components/modal/EditModal.vue";
import gql from "graphql-tag";
import EditableText, { SaveEventHandler } from "@/containers/EditableText.vue";

import { updateBuilding } from "@/graphql/mutation/updateBuilding";
import { updateBuildingGroup } from "@/graphql/mutation/updateBuildingGroup";

type Groups = { id: string; name: string }[];

interface Building {
  id: string;
  token: string;
  name: string;
  group: { id: string; name: string };
}

@Component({
  components: {
    CSelect,
    CButton,
    NoteBox,
    SimpleTable,
    EditIcon,
    EditModal,
    EditableText
  },
  apollo: {
    groups: {
      query: GROUP_ALL,
      update(data: GroupAllData): Groups {
        return data.groupFeed.groups;
      }
    },
    building: {
      query: gql`
        query($id: String!) {
          building(id: $id) {
            id
            token
            name
            group {
              id
              name
            }
            roomFeed(count: 999, page: 1) {
              rooms {
                id
                name
              }
            }
          }
        }
      `,
      variables() {
        const params = this.$apollo.vm.$route.params;
        return {
          id: params.buildingId
        };
      }
    }
  }
})
export default class BuildingEdit extends Vue {
  groups: Groups = [];
  building: Building | null = null;
  selectedValue: string | null = null;

  get loading(): boolean {
    return this.$apollo.loading;
  }

  get options(): SelectOption[] {
    return this.groups.map(g => ({ text: g.name, value: g.id }));
  }

  buildingTokenEditModal = false;
  buildingNameEditModal = false;

  async changeGroup() {
    const value = this.selectedValue;
    if (value === null) return alert("選択してください");

    const isChangeOK = confirm(`変更してよろしいですか？`);
    if(!isChangeOK) return false;

    await updateBuildingGroup(this.$apollo, {
      buildingId: this.$apollo.vm.$route.params.buildingId,
      groupId: value
    });
    alert("変更しました");
    this.selectedValue = null;
    // クエリ再取得
    // await this.$apollo.queries.building.refresh();
    // TODO: もし自分が子グループだったら権利がなくなるのでリダイレクト
    await this.$router.push({name: "buildings-list"})
  }

  async saveName(handler: SaveEventHandler) {
    handler(async (value: string) => {
      // 保存
      await updateBuilding(this.$apollo, {
        buildingId: this.$apollo.vm.$route.params.buildingId,
        name: value
      });
      alert("変更しました");
      // クエリ再取得
      await this.$apollo.queries.building.refresh();
    });
  }
}
